<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createModal from "./create_modal.vue";
import CreateGroupModal from "./create_group_modal.vue";
import Stocklar from "./stocklar.vue";
import Transfer from "../../stock/transfer.vue";
import Vericiler from "./vericiler.vue";
import Ariza from "./ariza.vue";
import DetailModal from "../router/detail_modal.vue";
import CoordinateMapModal from "./coordinate_map_modal.vue";
import PopMapModal from "./pop_map_modal.vue";
import datatableMixin from '@/helpers/mixins/datatableMixin';
import Datatable from '@/components/Datatable';
import { notify } from '@/helpers/notify';

const groupColumns = [
  { name: '', key: 'action', orderable: false, width: 52 },
  { name: 'Group Adı', key: 'name', orderable: true },
  { name: 'Altındaki Verici', key: 'transmitters_count', orderable: false, width: 140 },
  { name: 'Konum', key: 'coordinate', orderable: true },
  { name: 'Açıklama', key: 'explaine', orderable: false },
];

const listeColumns = [
  { name: '', key: 'action', orderable: false, width: 52 },
  { name: 'Verici Adı', key: 'name', orderable: true },
  { name: 'İp', key: 'ip', orderable: true },
  { name: 'Açıklama', key: 'explaine', orderable: false },
  { name: 'Durum', key: 'status', orderable: false, width: 100 },
];

export default {
  page: {
    title: "Verici Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    createModal,
    CreateGroupModal,
    Transfer,
    Stocklar,
    Vericiler,
    Ariza,
    DetailModal,
    CoordinateMapModal,
    PopMapModal,
    Datatable,
  },
  mixins: [datatableMixin],
  data() {
    return {
      list: {},
      title: "VERİCİ LİSTESİ",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "VERİCİ LİSTESİ", active: true },
      ],
      disableAutoLoad: true,
      endpoint: 'transmitter/groups',
      transferModal: 0,
      transferData: {},
      stockGroupId: 0,
      detailDevice: {},
      detailModalOpen: 0,
      columns: [...groupColumns],
      vericiTuru: 'group',
      vericiCounter: 0,
      vericiId: 0,
      vericiGroupName: '',
      arizaCounter: 0,
      arizaId: 0,
      stokCounter: 0,
      to: 'pop',
      mapOpen: 0,
      mapRow: null,
      mapCoordinate: '',
      popMapOpen: 0,
      form: {
        name: '',
        ip: '',
      },
      tableData: {
        detail: true,
        detailOpen: false,
        excel: false,
        data: [],
        pagination: {
          current_page: 1,
          last_page: 1,
          total: 0,
        },
        searchable: {
          visible: false,
          placeholder: '',
        },
      },
    };
  },
  watch: {
    vericiTuru(val) {
      if (val === 'liste') {
        this.endpoint = 'transmitter';
        this.columns = [...listeColumns];
        this.tableData.detail = true;
        this.tableData.detailOpen = true;
      } else {
        this.endpoint = 'transmitter/groups';
        this.columns = [...groupColumns];
        this.tableData.detail = false;
        this.tableData.detailOpen = false;
        this.form.name = '';
        this.form.ip = '';
      }
      this.searchParams = { ...this.form };
      this.sort = { column: null, order: null };
      this.params.page = 1;
      this.loadPage();
    },
  },
  mounted() {
    this.searchParams = { ...this.form };
    this.loadPage();
  },
  methods: {
    buildPayload() {
      const columnFilters = {};
      if (this.vericiTuru === 'liste') {
        if (this.searchParams.name) columnFilters.name = this.searchParams.name;
        if (this.searchParams.ip) columnFilters.ip = this.searchParams.ip;
      }

      return {
        columnFilters,
        sort: [
          {
            field: this.sort.column || '',
            type: this.sort.order || '',
          },
        ],
        page: this.params.page,
        perPage: this.params.per_page,
      };
    },

    async loadPage() {
      this.params.page === 1 ? this.isLoading = true : this.pageLoading = true;

      try {
        const response = await this.$http.post(this.endpoint, this.buildPayload());
        const rows = response.data.data || [];

        if (this.params.page === 1) {
          this.tableData.data = rows;
        } else {
          this.tableData.data = [...(this.tableData.data || []), ...rows];
        }

        this.tableData.pagination = {
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          total: response.data.total,
        };
      } finally {
        this.params.page === 1 ? this.isLoading = false : this.pageLoading = false;
      }
    },

    handleSortColumn(columnKey, sortOrder) {
      if (this.isLoading) return;
      this.sort.column = columnKey;
      this.sort.order = sortOrder;
      this.params.page = 1;
      this.loadPage();
    },

    handleFilterChange() {
      this.searchParams = { ...this.form };
      this.params.page = 1;
      this.loadPage();
    },

    clearFilter(field) {
      this.form[field] = '';
      this.handleFilterChange();
    },

    statusBadge(status) {
      if (status === 'Aktif' || status === 1) {
        return { class: 'bg-success', text: 'Aktif' };
      }
      if (status === 'Pasif' || status === 2) {
        return { class: 'bg-danger', text: 'Pasif' };
      }
      return { class: 'bg-secondary', text: status || '-' };
    },

    create() {
      this.list = {};
      this.$parent.$bvModal.show('modal-scoped');
    },

    update(props) {
      this.list = props;
      this.$parent.$bvModal.show('modal-scoped');
    },

    createGroup(props) {
      this.list = props || {};
      this.$parent.$bvModal.show('group-modal-scoped');
    },

    openTransferModal(prop) {
      this.transferModal += 1;
      this.transferData = { id: prop.id, stoktipi: 'pop', nereye: prop.name };
      this.$parent.$bvModal.show('transfer');
    },

    editVericiGrubu(props) {
      this.list = props;
      this.$parent.$bvModal.show('group-modal-scoped');
    },

    stokklar(props, to) {
      this.stockGroupId = props.id;
      this.stokCounter += 1;
      this.to = to;
      this.$parent.$bvModal.show('stoklar-modal-scoped');
    },

    altindakiVericiler(props) {
      this.vericiId = props.id;
      this.vericiGroupName = props.name || '';
      this.vericiCounter += 1;
      this.$parent.$bvModal.show('vericiler-scoped');
    },

    ariza(props) {
      this.arizaId = props.id;
      this.arizaCounter += 1;
      this.$parent.$bvModal.show('ariza-scoped');
    },

    openDetail(row) {
      this.detailDevice = {
        id: row.id,
        title: row.name,
        subtitle: row.ip,
      };
      this.detailModalOpen = Date.now();
      this.$parent.$bvModal.show('verici_detail_modal');
    },

    openCoordinate(row) {
      this.mapRow = row;
      this.mapCoordinate = row.coordinate || '';
      this.mapOpen = Date.now();
    },

    openAllPopMap() {
      this.popMapOpen = Date.now();
    },

    onPopMapEdit(marker) {
      this.openCoordinate({
        id: marker.id,
        name: marker.name,
        coordinate: marker.coordinate,
        address: marker.address,
        explaine: marker.explaine,
      });
    },

    async onListCoordinateConfirm(coord) {
      if (!this.mapRow || !this.mapRow.id) return;

      try {
        const payload = {
          ...this.mapRow,
          coordinate: coord || null,
          block: this.mapRow.ip_block || this.mapRow.block || null,
        };
        const resp = await this.$http.put(`/transmitter/groups/${this.mapRow.id}`, payload);
        if (resp.data && resp.data.code && resp.data.code !== 100) {
          return notify.error(resp.data.message || 'Konum güncellenemedi');
        }
        notify.success(resp.data.message || 'Konum güncellendi');
        this.loadPage();
      } catch (e) {
        notify.error('Konum güncellenemedi');
      }
    },

    sokum() {
      this.$http.post('transmitter/faults/store', {
        content: this.content,
        verici_id: this.vericiId,
        type: 2,
      }).then((response) => {
        this.loadPage();
        return notify.success(response.data.message);
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <create-modal :list="list" @loadItems="loadPage" />
    <CreateGroupModal :list="list" @loadItems="loadPage" />
    <Transfer :openModal="transferModal" :data="transferData" />
    <Stocklar :list="stockGroupId" :data="stokCounter" :to="to" />
    <Vericiler :list="vericiId" :data="vericiCounter" :groupName="vericiGroupName" />
    <Ariza :vericiId="arizaId" :counter="arizaCounter" @created="loadPage" />
    <DetailModal
      :device="detailDevice"
      :modelOpen="detailModalOpen"
      endpoint="/transmitter/details"
      title="Verici Detay"
      modalId="verici_detail_modal"
      :showWireless="true"
    />
    <CoordinateMapModal
      modal-id="list_pop_coordinate_map_modal"
      title="POP Konumu"
      :open="mapOpen"
      :value="mapCoordinate"
      @confirm="onListCoordinateConfirm"
    />
    <PopMapModal :open="popMapOpen" @edit="onPopMapEdit" />

    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: vericiTuru == 'group' }"
              href="#"
              @click.prevent="vericiTuru = 'group'"
            >POP Noktası Listesi</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: vericiTuru == 'liste' }"
              href="#"
              @click.prevent="vericiTuru = 'liste'"
            >Verici Listesi</a>
          </li>
        </ul>

        <Datatable
          :key="vericiTuru"
          :columns="columns"
          :tableData="tableData"
          tableDataLoad="scroll"
          @search-query="reLoadPage"
          @sort-column="handleSortColumn"
          :loading="isLoading"
          :poading="pageLoading"
        >
          <template #toolbar>
            <button
              v-if="vericiTuru == 'group'"
              class="btn btn-success me-2"
              type="button"
              @click="createGroup()"
            >Yeni POP Noktası Oluştur</button>

            <button
              v-if="vericiTuru == 'group'"
              class="btn btn-outline-primary"
              type="button"
              @click="openAllPopMap()"
            >
              <i class="bx bx-map"></i> POP Noktalarını Haritada Göster
            </button>

            <button
              v-if="vericiTuru == 'liste'"
              class="btn btn-success"
              type="button"
              @click="create()"
            >Yeni Verici Oluştur</button>
          </template>

          <template #searchItems>
            <div class="col-md-4" v-if="vericiTuru == 'liste'">
              <div class="mb-3">
                <label class="d-flex justify-content-between">
                  Verici Adı
                  <span
                    v-if="form.name"
                    class="text-danger"
                    style="cursor:pointer"
                    @click="clearFilter('name')"
                  >temizle</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.name"
                  placeholder="Verici adı ara..."
                  @keyup.enter="handleFilterChange"
                  @change="handleFilterChange"
                >
              </div>
            </div>
            <div class="col-md-4" v-if="vericiTuru == 'liste'">
              <div class="mb-3">
                <label class="d-flex justify-content-between">
                  IP
                  <span
                    v-if="form.ip"
                    class="text-danger"
                    style="cursor:pointer"
                    @click="clearFilter('ip')"
                  >temizle</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.ip"
                  placeholder="IP ara..."
                  @keyup.enter="handleFilterChange"
                  @change="handleFilterChange"
                >
              </div>
            </div>
          </template>

          <template #status="{ row }">
            <span class="badge rounded-pill" :class="statusBadge(row.status).class">
              {{ statusBadge(row.status).text }}
            </span>
          </template>

          <template #transmitters_count="{ row }">
            <a
              href="javascript:void(0)"
              class="text-primary fw-semibold"
              @click.prevent="altindakiVericiler(row)"
            >
              {{ row.transmitters_count || 0 }}
            </a>
          </template>

          <template #coordinate="{ row }">
            <a
              href="javascript:void(0)"
              class="text-primary"
              @click.prevent="openCoordinate(row)"
            >
              <template v-if="row.coordinate">
                <i class="bx bx-map"></i> {{ row.coordinate }}
              </template>
              <template v-else>
                <i class="bx bx-map-pin"></i> Konum Seç
              </template>
            </a>
          </template>

          <template #explaine="{ row }">
            <span v-b-popover.hover.auto="row.explaine">{{ row.explaine }}</span>
          </template>

          <template #action="{ row }">
            <b-dropdown
              toggle-class="font-size-16 p-0"
              toggle-tag="a"
              variant="white"
              append-to-body
            >
              <template #button-content>
                <i class="mdi mdi-dots-horizontal"></i>
              </template>

              <template v-if="vericiTuru == 'liste'">
                <b-dropdown-item @click="openDetail(row)">Detay</b-dropdown-item>
                <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
                <b-dropdown-item @click="ariza(row)">Arıza Kaydı Aç</b-dropdown-item>
                <b-dropdown-item @click="stokklar(row, 'verici')">Cihaz Stokları</b-dropdown-item>
              </template>

              <template v-else>
                <b-dropdown-item @click="editVericiGrubu(row)">Güncelle</b-dropdown-item>
                <b-dropdown-item @click="stokklar(row, 'pop')">Cihaz Stokları</b-dropdown-item>
                <b-dropdown-item @click="openTransferModal(row)">Buraya Transfer Et</b-dropdown-item>
                <b-dropdown-item @click="altindakiVericiler(row)">Pop Altındaki Vericiler</b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
